<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconFullscreenOn_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M13.325 3.156H20.2c.356 0 .644.288.644.644v6.875a.644.644 0 0 1-1.254.205l-1.183-3.519-3.573 3.573a1.25 1.25 0 0 1-1.768-1.768l3.573-3.573L13.12 4.41a.642.642 0 0 1 .205-1.254M7.361 18.407l3.519 1.183a.642.642 0 0 1-.205 1.254H3.8a.644.644 0 0 1-.644-.644v-6.875a.644.644 0 0 1 1.254-.205l1.183 3.519 3.573-3.573a1.25 1.25 0 1 1 1.768 1.768z"
        clip-rule="evenodd"
    />
</svg>
